import { Alert, Box } from "@mui/material";
import { observer } from "mobx-react-lite";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useLocation } from "react-router-dom";
import { useAppStore } from "../../../hooks/useStores";
import styles from "./PluginLoginStatus.module.scss";

const PluginLoginStatus = observer(() => {
	const location = useLocation();
	const { t } = useTranslation();
	const { success = false } = location.state || {};
	const { authStore } = useAppStore();

	useEffect(() => {
		authStore.isPluginAuth = false;
		authStore.pluginAuthId = undefined;
	}, []);

	return (
		<Box>
			{
				<Alert severity={success ? "success" : "error"} className={styles.success}>
					{success ? t("pluginSuccessLogin") : t("pluginFailedLogin")}
				</Alert>
			}
		</Box>
	);
});

export default PluginLoginStatus;
